export const languages = [
  { code: 'en', name: 'English', flag: '\u{1F1FA}\u{1F1F8}' },
  { code: 'es', name: 'Espa\u00F1ol', flag: '\u{1F1EA}\u{1F1F8}' },
  { code: 'fr', name: 'Fran\u00E7ais', flag: '\u{1F1EB}\u{1F1F7}' },
  { code: 'pt', name: 'Portugu\u00EAs', flag: '\u{1F1E7}\u{1F1F7}' },
];

export const fontFamilyOptions = [
  { key: 'Sans Serif', label: 'Sans Serif' },
  { key: 'Serif', label: 'Serif' },
  { key: 'Roboto', label: 'Roboto' },
  { key: 'Merriweather', label: 'Merriweather' },
];

export const fontSizeOptions = [
  { key: 'small', label: 'S', fullLabel: 'Small', cls: 'text-sm' },
  { key: 'normal', label: 'M', fullLabel: 'Normal', cls: 'text-base' },
  { key: 'large', label: 'L', fullLabel: 'Large', cls: 'text-lg' },
  { key: 'extra-large', label: 'XL', fullLabel: 'Extra Large', cls: 'text-xl' },
];

export const mainTranslations = ['kjv', 'esv', 'amp', 'nasb', 'lsb', 'asv', 'web', 'ylt', 'rvr09', 'ls1910', 'almeida', 'lbla'];

export const translationCredits = {
  kjv: { name: 'King James Version', notice: 'Public Domain' },
  esv: { name: 'English Standard Version', notice: 'Scripture quotations are from The ESV\u00ae Bible (The Holy Bible, English Standard Version\u00ae), \u00a9 2001 by Crossway, a publishing ministry of Good News Publishers. Used by permission. All rights reserved.' },
  amp: { name: 'Amplified Bible', notice: 'Scripture quotations taken from the Amplified\u00ae Bible (AMP), Copyright \u00a9 2015 by The Lockman Foundation. Used by permission. lockman.org' },
  nasb: { name: 'New American Standard Bible', notice: 'Scripture quotations taken from the (NASB\u00ae) New American Standard Bible\u00ae, Copyright \u00a9 1960, 1971, 1977, 1995 by The Lockman Foundation. Used by permission. All rights reserved. lockman.org' },
  lsb: { name: 'Legacy Standard Bible', notice: 'Scripture quotations taken from the (LSB\u00ae) Legacy Standard Bible\u00ae, Copyright \u00a9 2021 by The Lockman Foundation. Used by permission. All rights reserved. Managed in partnership with Three Sixteen Publishing Inc. LSBible.org and 316publishing.com.' },
  asv: { name: 'American Standard Version', notice: 'Public Domain' },
  web: { name: 'World English Bible', notice: 'Public Domain' },
  ylt: { name: "Young's Literal Translation", notice: 'Public Domain' },
  rvr09: { name: 'Reina-Valera 1909', notice: 'Public Domain' },
  ls1910: { name: 'Louis Segond 1910', notice: 'Public Domain' },
  almeida: { name: 'Almeida Revista e Corrigida', notice: 'Public Domain' },
  lbla: { name: 'La Biblia de las Am\u00e9ricas', notice: 'Scripture quotations taken from La Biblia de las Am\u00e9ricas\u00ae (LBLA), Copyright \u00a9 1986, 1995, 1997 by The Lockman Foundation. Used by permission. lockman.org' },
};

export const days = [
  { value: 'monday', label: 'Mon' },
  { value: 'tuesday', label: 'Tue' },
  { value: 'wednesday', label: 'Wed' },
  { value: 'thursday', label: 'Thu' },
  { value: 'friday', label: 'Fri' },
  { value: 'saturday', label: 'Sat' },
  { value: 'sunday', label: 'Sun' },
];

export const times = ['06:00','07:00','08:00','09:00','10:00','11:00','12:00','13:00','14:00','15:00','16:00','17:00','18:00','19:00','20:00','21:00'];

export const timezones = [
  { value: 'America/New_York', label: 'Eastern (ET)' },
  { value: 'America/Chicago', label: 'Central (CT)' },
  { value: 'America/Denver', label: 'Mountain (MT)' },
  { value: 'America/Los_Angeles', label: 'Pacific (PT)' },
  { value: 'America/Anchorage', label: 'Alaska (AKT)' },
  { value: 'Pacific/Honolulu', label: 'Hawaii (HT)' },
  { value: 'Europe/London', label: 'London (GMT/BST)' },
  { value: 'Europe/Paris', label: 'Central Europe (CET)' },
  { value: 'Europe/Berlin', label: 'Berlin (CET)' },
  { value: 'Africa/Lagos', label: 'West Africa (WAT)' },
  { value: 'Africa/Nairobi', label: 'East Africa (EAT)' },
  { value: 'Africa/Johannesburg', label: 'South Africa (SAST)' },
  { value: 'Asia/Dubai', label: 'Gulf (GST)' },
  { value: 'Asia/Kolkata', label: 'India (IST)' },
  { value: 'Asia/Shanghai', label: 'China (CST)' },
  { value: 'Asia/Tokyo', label: 'Japan (JST)' },
  { value: 'Asia/Seoul', label: 'Korea (KST)' },
  { value: 'Australia/Sydney', label: 'Sydney (AEST)' },
  { value: 'Pacific/Auckland', label: 'New Zealand (NZST)' },
  { value: 'America/Sao_Paulo', label: 'Brasilia (BRT)' },
  { value: 'America/Mexico_City', label: 'Mexico City (CST)' },
  { value: 'America/Bogota', label: 'Colombia (COT)' },
];

export const glassCard = {
  background: 'var(--glass-bg)',
  backdropFilter: 'blur(20px)',
  WebkitBackdropFilter: 'blur(20px)',
  border: '1px solid var(--glass-border)',
};

export const glassOption = (selected) => ({
  background: selected ? 'var(--glass-bg-active)' : 'transparent',
  border: `1.5px solid ${selected ? 'var(--theme-accent)' : 'var(--glass-border)'}`,
});

export const formatTime = (tm) => {
  const [h, m] = tm.split(':');
  const hour = parseInt(h, 10);
  const ampm = hour >= 12 ? 'PM' : 'AM';
  const hour12 = hour === 0 ? 12 : hour > 12 ? hour - 12 : hour;
  return `${hour12}:${m} ${ampm}`;
};
